import React from 'react';
import { StyledBar } from './styledBar';
import { Breakpoint } from '../common';
export var getNormalizedProgress = function getNormalizedProgress(progress) {
  return Math.min(1, Math.max(0, progress || 0)) * 100;
};
export var ProgressBar = function ProgressBar(_ref) {
  var progress = _ref.progress,
    _ref$breakpoint = _ref.breakpoint,
    breakpoint = _ref$breakpoint === void 0 ? Breakpoint.SMALL : _ref$breakpoint,
    _ref$positionBottom = _ref.positionBottom,
    positionBottom = _ref$positionBottom === void 0 ? false : _ref$positionBottom,
    _ref$showOnTop = _ref.showOnTop,
    showOnTop = _ref$showOnTop === void 0 ? false : _ref$showOnTop;
  return /*#__PURE__*/React.createElement(StyledBar, {
    progress: getNormalizedProgress(progress),
    breakpoint: breakpoint,
    positionBottom: positionBottom,
    showOnTop: showOnTop
  });
};